import { SagaIterator } from 'redux-saga'
import { put, call, takeLatest, fork, takeEvery } from 'redux-saga/effects'
import {
  getPatientSmsLogsData,
  sendPatientSmsLogsData as sendPatientSmsData,
} from './api'
import { GET_PATIENT_SMS_LOGS, SEND_PATIENT_SMS } from './actionTypes'
import {
  errorPatientSmsLogs,
  addPatientSmsLogs,
  getPatientSmsLogs,
  successPatientSmsLogs,
} from './patientSmsLogsReducer'
import { PatientSmsLogsType } from './types'

type Action = {
  type: string
  payload: string
}

export function* handleGetPatientSmsLogsData(
  actions: Action
): SagaIterator<void> {
  try {
    const response = yield call(getPatientSmsLogsData, actions.payload)
    const { data } = response
    let modifiedData: PatientSmsLogsType = {
      key: actions.payload,
      smsLogs: data.smsLog,
    }
    yield put(addPatientSmsLogs(modifiedData))
  } catch (error: any) {
    yield put(errorPatientSmsLogs(error.response.data.message))
  }
}

type SendSmsAction = {
  type: string
  payload: {
    patientKey: string
    smsMsg: string
  }
}

export function* handleSendPatientSmsLog(
  actions: SendSmsAction
): SagaIterator<void> {
  try {
    let smsData = {
      smsMsg: actions.payload.smsMsg,
    }
    let { data } = yield call(
      sendPatientSmsData,
      actions.payload.patientKey,
      smsData
    )
    yield put(getPatientSmsLogs(actions.payload.patientKey))
    yield put(successPatientSmsLogs(data.status))
  } catch (error: any) {
    yield put(errorPatientSmsLogs(error.response.data.message))
  }
}

export function* watcherSaga() {
  yield takeEvery(GET_PATIENT_SMS_LOGS, handleGetPatientSmsLogsData)
  yield takeEvery(SEND_PATIENT_SMS, handleSendPatientSmsLog)
}

export const patientSmsLogsSaga = [fork(watcherSaga)]
